import React from 'react';
import './Header.css'


const titleStyle = {
    marginTop: '14px'
}

const Header = (props) => (
    <header className="Header">
        <h2>{props.subtitle}</h2>
        <h1 style={titleStyle}>{props.title}</h1>
    </header>
);
export default Header;